import React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./orderDetails.css";
import "./orderDetails2.css";
import "../../analytics/analytics.css";
import { styled } from "@mui/material/styles";
import { Divider, Paper, Skeleton, Tooltip, Typography } from "@mui/material";
import { OrderCategoryDetailsGrid } from "./OrderCategoryDetailsGrid";
import { TimelineDetails } from "./TimelineDetails";
import timelineScenarios from "./TimelineScenarios";
import RefundDialog from "./RefundDialog";
import { useAuth } from "../../../context/API_Client";
import SmallModal from "../../../reusableComponents/modals/SmallModal";
import CustomButton from "../../../reusableComponents/CustomButton";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { statusColorSchema } from "./StatusColorSchema";
import CoinsColoredIcon from "../../../../assets/svg/coins-colored.svg";
import CoinColoredIcon from "../../../../assets/svg/coin-colored.svg";
import MoneyStackColored from "../../../../assets/svg/money-stack-colored.svg";
import UserCheckColored from "../../../../assets/svg/user-check-alt-1-colored.svg";
import LaptopIcon from "../../../../assets/svg/Laptop.svg";
import ClockCheckedColoredIcon from "../../../../assets/svg/clock-check-colored.svg";
import { camelCaseToNormal, convertIsoToGivenDateFormat, isEmpty } from "../../utils/utils";

import { colorBrandObject } from "../../../../constants/brandings";
import { iconDefaultColor } from "../../../reusableComponents/constants";
import ReadMoreText from "../../../reusableComponents/readMore/ReadMoreText";
import SplitPaymentModal from "./splitPayment/SplitPaymentModal";
import SplitPaymentDetails from "./splitPayment/SplitPaymentDetails";
import SplitPaymentRefundModal from "./splitPayment/SplitPaymentRefundModal";
import RejectModal from "../../ApprovalRequest/RejectModal";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ContentHeader from "../../../reusableComponents/contentHeader/ContentHeader";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  boxShadow: "none",
  borderRadius: "20px",
  background:
    "linear-gradient(98deg, #F8F8FF -0.82%, rgba(250, 250, 255, 0.60) 113.08%)",
  display: "flex",
  paddingTop: "20px",
}));

function OrderDetails(operationPermissions) {
  const navigate = useNavigate();

  const {
    getOrderDetails,
    getAllPspConfigs,
    getPaymentMethod,
    captureRefundPayment,
    getOrderDetailsTimeline,
    getRefundReasons,
    timezone,
    refreshOrderDetail,
    getProductDetailsById,
    approveRefundRequest,
    isAuthorizedPermission,
    setApprovalCount,
    merchantSettings
  } = useAuth();

  const [gridData, setGridData] = useState({});
  const [orderDetailsData, setOrderDetailsData] = useState();
  const [paymentMethodData, setPaymentMethodData] = useState([]);
  const [paymentMethodInfo, setPaymentMethodInfo] = useState([]);
  const [processorData, setProcessorData] = useState([]);
  const [timeline, setTimeline] = useState([]);
  const [toggleDialogRefund, setToggleDialogRefund] = useState(false);
  const [toggleDialogCapture, setToggleDialogCapture] = useState(false);
  const [toggleDialogVoid, setToggleDialogVoid] = useState(false);
  const [recentOperation, setRecentOperation] = useState();
  const [statusColor, setStatusColor] = useState("");
  const [statusFontColor, setStatusFontColor] = useState("");
  const [refundCaptureError, setRefundCaptureError] = useState("");
  const [voidError, setVoidError] = useState("");
  const [reasonsToSend, setReasonsToSend] = useState();
  const [reasonsToDisplay, setReasonsToDisplay] = useState();
  const [refundReasons, setRefundReasons] = useState();
  const [paymentType, setPaymentType] = useState();
  const [upiId, setUpiId] = useState("");
  const [remainingRefundableAmount, setRemainingRefundableAmount] = useState();
  const [remainingCapturableAmount, setRemainingCapturableAmount] = useState();
  const [refundInitiated, setRefundInitiated] = useState("initiated");
  const [saleAuthApproved, setSaleAuthApproved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [statusLoader, setStatusLoader] = useState(false);
  const [splitPaymentModal, setSplitPaymentModal] = useState(false)
  const [approvalLoader, setApprovalLoader] = useState(false);
  const [isRejectModal, setIsRejectModal] = useState(false);
  const [rejectModalData, setRejectModalData] = useState({})
  const [
    toggleInvalidTrasactionIdErrorDialog,
    setToggleInvalidTransactionIdErrorDialog,
  ] = useState(false);
  const [toggleNoTrasactionIdErrorDialog, setToggleNoTransactionIdErrorDialog] =
    useState(false);

  const [productData, setProductData] = useState(null)
  const [splitPaymentRefundModal, setSplitPaymentRefundModal] = useState(false)
  const [merchantSetting, setMerchantSetting] = useState()


  const flattenJSON = (obj = {}, res = {}, extraKey = "") => {
    for (const key in obj) {
      if (typeof obj[key] !== "object") {
        res[extraKey + key] = obj[key];
      } else if (Array.isArray(obj[key])) {
        res[key] = obj[key];
      } else {
        flattenJSON(obj[key], res, `${extraKey}${key}.`);
      }
    }
    return res;
  };

  const handleRejectModal = (data) => {
    setIsRejectModal(true)
    const modalData = {
      operationId: data.operationId,
      userId: data.actorId,
      transactionId: transactionIdData
    }
    setRejectModalData(modalData)
  }
  useEffect(() => {
    if (timeline && gridData && refundInitiated != null) {
      setLoading(false);
    }
  }, [gridData, refundInitiated, timeline]);

  const getTimeLine = () => {
    getOrderDetails(
      transactionIdData,
      function (data) {
        setOrderDetailsData(data);
        setRemainingCapturableAmount(data?.remainingCapturableAmount?.amount);
        setRemainingRefundableAmount(data?.remainingRefundableAmount?.amount);
        const flattenedData = flattenJSON(data);
        setGridData(flattenedData);
        setUpiId(data?.authorisation?.shopperVpa);
        const productId = data?.basicDetails?.metadata?.productCode
        if (productId) {

          getProductDetailsById(productId, (data) => {
            setProductData(data)
          }, (err) => {
            customToast("error", "high", err);
          })
        }

        getOrderDetailsTimeline(
          transactionIdData,
          (data) => {
            let timelineData = data?.reverse();

            let status = timelineData?.find(
              (element) =>
                element?.status?.operation === "Partial_Refund" ||
                element?.status?.operation === "Refund"
            )?.status?.statusLocale;
            if (status === "Initiated") {
              setRefundInitiated(true);
            } else {
              setRefundInitiated(false);
            }

            let AuthSaleStatus = timelineData?.find(
              (element) => element?.status?.operation === "Authorisation"
            )?.status?.statusLocale;
            if (AuthSaleStatus === "Approved") {
              setSaleAuthApproved(true);
            } else {
              setSaleAuthApproved(false);
            }
            setTimeline(timelineData);
          },
          (errorMsg) => {
            if (errorMsg === "noTransactionId") {
              setToggleNoTransactionIdErrorDialog(true);
            } else if (errorMsg === "invalidTransactionId") {
              setToggleInvalidTransactionIdErrorDialog(true);
            } else {
              customToast("error", "high", errorMsg);
            }
          }
        );
      },
      function (errorMsg) {
        if (errorMsg === "noTransactionId") {
          setToggleNoTransactionIdErrorDialog(true);
        } else if (errorMsg === "invalidTransactionId") {
          setToggleInvalidTransactionIdErrorDialog(true);
        } else {
          customToast("error", "high", errorMsg);
        }
      },
      operationPermissions
    );
  };

  const postActionForRefund = () => {
    getTimeLine()
    setApprovalCount(state => state - 1)
  }

  useEffect(() => {
    if (timeline?.length > 0) {
      setRecentOperation(
        timelineScenarios(timeline[0], refundReasons, timezone, approveTransactionRequest, approvalLoader, isAuthorizedPermission)
      );
      setStatusColor(
        statusColorSchema[timeline[0]?.status?.status]?.background
      );
      setStatusFontColor(statusColorSchema[timeline[0]?.status?.status]?.text);
    }
  }, [refundReasons, timeline]);

  const initiateCaptureRefund = (payload, id, val, uuid, is_agent) => {
    captureRefundPayment(
      gridData["basicDetails.transactionId"],
      id,
      payload,
      function (res) {
        updateToggleDialog(false, val);
        setSplitPaymentRefundModal(false)
        if (val === "Refund") {
          if (is_agent) {
            customToast(
              "warning",
              "medium",
              "Refund review request sent to Approver"
            );
          } else {

            customToast(
              "success",
              "medium",
              "Refund has been initiated and we will update basis confirmation by the processor"
            );
          }
        }
        getTimeLine();
      },
      function (err) {
        setVoidError(err?.response?.data?.message);
        setRefundCaptureError(err?.response?.data?.message);
        getTimeLine();
      },
      uuid
    );
  };

  useEffect(() => {
    getAllPspConfigs(
      function (data) {
        setProcessorData(data);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    getTimeLine();
    getPaymentMethod(
      function (data) {
        setPaymentMethodData(data);
        setPaymentMethodInfo(
          data?.find(
            (obj) =>
              obj.brand === gridData["basicDetails.emiMethod.brand"] ||
              obj.brand === gridData["basicDetails.paymentMethod.brand"]
          )?.logoUrl
        );
        setPaymentType(
          data?.find(
            (obj) =>
              obj.brand === gridData["basicDetails.emiMethod.brand"] ||
              obj.brand === gridData["basicDetails.paymentMethod.brand"]
          )?.typeTitle
        );
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    const reasonsName = [];
    const reasonsLabel = [];

    getRefundReasons(
      function (data) {
        setRefundReasons(data);
        for (let index = 0; index < data?.length; index++) {
          reasonsName.push(data[index]?.name);
          reasonsLabel.push(data[index]?.label);
        }
        setReasonsToDisplay(reasonsLabel);
        setReasonsToSend(reasonsName);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  const updateError = (val) => {
    setRefundCaptureError(val);
    setVoidError(val);
  };

  const handleCopy = (val) => {
    navigator.clipboard.writeText(gridData["basicDetails.transactionId"]);
    customToast("success", "medium", `Transaction ID copied`);
  };

  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const isApprovalDetail = location?.pathname?.includes('approvals')

  const transactionIdData = queryParameters.get("transactionId");
  const refreshStatus = async () => {
    setStatusLoader(true);
    refreshOrderDetail(
      transactionIdData,
      function () {
        getOrderDetailsTimeline(
          transactionIdData,
          (data) => {
            let timelineData = data?.reverse();

            let status = timelineData?.find(
              (element) =>
                element?.status?.operation === "Partial_Refund" ||
                element?.status?.operation === "Refund"
            )?.status?.statusLocale;
            if (status === "Initiated") {
              setRefundInitiated(true);
            } else {
              setRefundInitiated(false);
            }

            let AuthSaleStatus = timelineData?.find(
              (element) => element?.status?.operation === "Authorisation"
            )?.status?.statusLocale;
            if (AuthSaleStatus === "Approved") {
              setSaleAuthApproved(true);
            } else {
              setSaleAuthApproved(false);
            }
            setTimeline(timelineData);
          },
          (errorMsg) => {
            if (errorMsg === "noTransactionId") {
              setToggleNoTransactionIdErrorDialog(true);
            } else if (errorMsg === "invalidTransactionId") {
              setToggleInvalidTransactionIdErrorDialog(true);
            } else {
              customToast("error", "high", errorMsg);
            }
          }
        );
        setStatusLoader(false);
        customToast("success", "high", " Status Fetched Successfully")
      },
      function () {
        customToast("error", "high", "Failed To Fetch Status")
        setStatusLoader(false);
      }
    );
  };

  const updateToggleDialog = (toggle, val) => {
    if (val === "Refund") {
      setToggleDialogRefund(toggle);
    } else if (val === "Capture") {
      setToggleDialogCapture(toggle);
    } else {
      setToggleDialogVoid(toggle);
    }
  };

  // details?.authorisation?.splitSettlements
  const handleCreateRefund = () => {
    const isOnlyAggregator = orderDetailsData?.authorisation?.splitSettlements?.length == 1 && orderDetailsData?.authorisation?.splitSettlements?.filter(el => el.subMerchantId?.toLowerCase() == "aggregator")?.length
    if (orderDetailsData?.authorisation?.splitSettlements?.length && !isOnlyAggregator) {
      setSplitPaymentRefundModal(true)
    } else {
      updateToggleDialog(!toggleDialogRefund, "Refund")
    }
  }
  const handleShowRefund = () => {
    if (
      parseFloat(remainingRefundableAmount) > 0 &&
      !refundInitiated &&
      saleAuthApproved && !orderDetailsData?.authorisation.splitSettlementsInstructionsRequired &&
      saleAuthApproved && !isApprovalDetail
    ) {
      return (
        <CustomButton
          text={"Create Refund"}
          type={"primary"}
          variant={"contained"}
          size={"sm"}
          onClick={() => handleCreateRefund()}
        />
      );
    }
    return <></>;
  };
  const handleSplitPayment = () => {
    if (orderDetailsData?.authorisation.splitSettlementsInstructionsRequired) {
      return <CustomButton
        text={"Split Settlement"}
        type={"primary"}
        variant={"outlined"}
        size={"sm"}
        onClick={() => setSplitPaymentModal(true)}
      />
    }
    return <></>

  };

  const handleShowRefresh = () => {
    if (orderDetailsData?.fetchStatusAPISupported && !isApprovalDetail) {
      return (
        <CustomButton
          text={"Fetch Status"}
          type={"primary"}
          variant={"outlined"}
          size={"sm"}
          loading={statusLoader}
          onClick={() => refreshStatus()}
        />
      );
    }
    return <></>;
  };

  const handleShowCapture = () => {
    let isDominant = true;
    if (
      gridData["authorisation.paymentType"] === "A" &&
      parseFloat(remainingCapturableAmount) > 0 &&
      !gridData["cancelled"] && !isApprovalDetail
    ) {
      if (
        parseFloat(remainingRefundableAmount) > 0 &&
        !refundInitiated &&
        saleAuthApproved
      ) {
        isDominant = false;
      } else {
        isDominant = true;
      }
      return (
        <CustomButton
          text={"Capture"}
          type={"primary"}
          size={"sm"}
          variant={isDominant ? "contained" : "outlined"}
          onClick={() => updateToggleDialog(!toggleDialogRefund, "Capture")}
        />
      );
    }
    return <></>;
  };

  const handleShowVoid = () => {
    if (
      gridData["authorisation.paymentType"] === "A" &&
      parseFloat(remainingCapturableAmount) === parseFloat(gridData["authorisation.money.amount"]) &&
      !gridData["cancelled"] && !isApprovalDetail
    ) {
      return (
        <CustomButton
          text={"Void"}
          type={"primary"}
          variant={"outlined"}
          size={"sm"}
          onClick={() => updateToggleDialog(!toggleDialogRefund, "Void")}
        />
      );
    }
    return <></>;
  };

  const handleNoTrasactionIdDialog = () => {
    setToggleNoTransactionIdErrorDialog(false);
    navigate("/transactions");
  };

  const handleInvalidTrasactionIdDialog = () => {
    setToggleNoTransactionIdErrorDialog(false);
    navigate("/transactions");
  };

  const isStringAndNotNumber = (value) => {
    return typeof value === "string" && !/^\d+$/.test(value);
  };

  const approveTransactionRequest = async (data) => {
    try {
      if (!orderDetailsData?.refunds?.length) return
      const refundId = data?.operationId
      setApprovalLoader(true)
      approveRefundRequest(orderDetailsData.transactionId, refundId, () => {
        customToast("success", "high", `Request approved for “${data.actorId}”`)
        postActionForRefund()
        setApprovalLoader(false)
      }, (errorMsg) => {
        setApprovalLoader(false)
        customToast("error", "high", errorMsg || "Something went wrong")
      })
    } catch (err) {
      setApprovalLoader(false)
      customToast("error", "high", "Something went wrong")
    }
  }
  const handleShowRefundDetails = () => {
    const refunds = orderDetailsData?.refunds || []
    let approvedRefundData = refunds.filter(el => {
      if (el?.pspResponses?.length) {
        const latestRes = el?.pspResponses[0]
        if (latestRes?.status?.operation && (latestRes?.status?.operation == "Approved" || latestRes?.status?.operation == "Partial_Approved" || latestRes?.status?.operation == "Partial_Refund")) {
          return true
        }
      }
    })
    if (approvedRefundData?.length) {
      return <div style={{ display: "flex", paddingTop: "24px" }}>
        <div className="card-logo">
          <MoneyStackColored
            stroke={`${colorBrandObject?.primaryButtonColor}`}
          />
        </div>
        <div className="card-payment-info">
          <div className="card-details"></div>
          <div className="card-payment-info">
            <div className="card-details text-limiter">
              <Typography className="bodyB1MediumColored">
                Refund Details
              </Typography>


              {approvedRefundData.map(el => {
                return <>
                  <div className="order-category-root">
                    <div className="order-category">

                      <Typography className="labelSemiBoldColored">Amount</Typography>
                      <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}>{el?.money?.currencyCode} {el?.money?.amountLocaleFull}</Typography>
                    </div>
                    <div className="order-category">
                      <Typography className="labelSemiBoldColored">Updated At</Typography>
                      <Tooltip
                        title={el?.updatedOn ? convertIsoToGivenDateFormat(el?.updatedOn, timezone) : ""}
                        placement="right-start"
                        arrow
                        followCursor
                      >
                        <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}>{el?.updatedOn ? convertIsoToGivenDateFormat(el?.updatedOn, timezone) : ""}</Typography>
                      </Tooltip>
                    </div>
                    <div className="order-category">
                      <Typography className="labelSemiBoldColored"> Initiated by</Typography>
                      <Tooltip
                        title={el?.userId}
                        placement="right-start"
                        arrow
                        followCursor
                      >
                        <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}>{el?.userId}</Typography>
                      </Tooltip>
                    </div >
                    {el?.refundReason && <div className="order-category">
                      <Typography className="labelSemiBoldColored">Refund Reason</Typography>
                      <Tooltip
                        title={el?.refundReason}
                        placement="right-start"
                        arrow
                        followCursor
                      >
                        <Typography className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}>{camelCaseToNormal(el?.refundReason)}</Typography>
                      </Tooltip>
                    </div>}
                  </div>
                  <div style={{ paddingRight: "36px" }}>
                    <Divider />
                  </div>
                </>
              })}


            </div>

          </div >

        </div>
      </div>


    }
    return <></>
  }

  useEffect(() => {
    merchantSettings(
      function (data) {
        setMerchantSetting(data);
      },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
      }
    );
  }, [])
  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content">
          <SmallModal
            headerText={"Invalid transaction ID"}
            subHeaderText={
              "Please enter the correct transaction Id or click on the button below to go back"
            }
            filledBtnText={"Go Back"}
            filledBtnFunction={handleInvalidTrasactionIdDialog}
            toggleDialog={toggleInvalidTrasactionIdErrorDialog}
          />
          <SmallModal
            headerText={"Transaction ID not found"}
            subHeaderText={
              "Please checK the URL, as the transaction ID parameter is missing. Please enter the transaction ID parameter in the URL or click on the button below to go back"
            }
            filledBtnText={"Go Back"}
            filledBtnFunction={handleNoTrasactionIdDialog}
            toggleDialog={toggleNoTrasactionIdErrorDialog}
          />
          {reasonsToDisplay && reasonsToSend && (
            <RefundDialog
              merchantSetting={merchantSetting}
              gridData={gridData}
              paymentMethodData={paymentMethodData}
              toggleDialog={toggleDialogRefund}
              updateToggleDialog={updateToggleDialog}
              val="Refund"
              remainingAmount={remainingRefundableAmount}
              initiateVoidCaptureRefund={initiateCaptureRefund}
              initiateVoidCaptureRefundError={refundCaptureError}
              updateInitiateVoidCaptureRefundError={updateError}
              reasonsToDisplay={reasonsToDisplay}
              reasonsToSend={reasonsToSend}
              isAuthorizedPermission={isAuthorizedPermission}
            />
          )}
          {splitPaymentRefundModal && <SplitPaymentRefundModal
            merchantSetting={merchantSetting}
            gridData={gridData}
            details={orderDetailsData}
            paymentMethodData={paymentMethodData}
            toggleDialog={splitPaymentRefundModal}
            updateToggleDialog={setSplitPaymentRefundModal}
            val="Refund"
            remainingAmount={remainingRefundableAmount}
            initiateVoidCaptureRefund={initiateCaptureRefund}
            initiateVoidCaptureRefundError={refundCaptureError}
            updateInitiateVoidCaptureRefundError={updateError}
            reasonsToDisplay={reasonsToDisplay}
            reasonsToSend={reasonsToSend}
            currencyCode={orderDetailsData?.remainingRefundableAmount?.currencyCode}
            isAuthorizedPermission={isAuthorizedPermission}

          />}
          <RefundDialog
            gridData={gridData}
            paymentMethodData={paymentMethodData}
            toggleDialog={toggleDialogCapture}
            merchantSetting={merchantSetting}
            updateToggleDialog={updateToggleDialog}
            val="Capture"
            remainingAmount={remainingCapturableAmount}
            initiateVoidCaptureRefund={initiateCaptureRefund}
            initiateVoidCaptureRefundError={refundCaptureError}
            updateInitiateVoidCaptureRefundError={updateError}
            reasonsToDisplay={reasonsToDisplay}
            reasonsToSend={reasonsToSend}
            isAuthorizedPermission={isAuthorizedPermission}
          />
          <RefundDialog
            gridData={gridData}
            paymentMethodData={paymentMethodData}
            merchantSetting={merchantSetting}
            toggleDialog={toggleDialogVoid}
            updateToggleDialog={updateToggleDialog}
            val="Void"
            remainingAmount={remainingRefundableAmount}
            initiateVoidCaptureRefund={initiateCaptureRefund}
            initiateVoidCaptureRefundError={voidError}
            updateInitiateVoidCaptureRefundError={updateError}
            reasonsToDisplay={reasonsToDisplay}
            reasonsToSend={reasonsToSend}
            isAuthorizedPermission={isAuthorizedPermission}
          />

          {orderDetailsData?.authorisation.splitSettlementsInstructionsRequired && splitPaymentModal &&
            <SplitPaymentModal getTimeLine={getTimeLine} currencyCode={orderDetailsData?.remainingRefundableAmount?.currencyCode} updateToggleDialog={setSplitPaymentModal} toggleDialog={splitPaymentModal} totalAmount={orderDetailsData?.basicDetails?.originalAuthAmount} transactionID={transactionIdData} />
          }
          <div className={`d-flex align-items-center  w-100 ${isApprovalDetail ? "justify-content-between" : "justify-content-end"} `} >


            <div style={{ width: "30%" }}> <ContentHeader
              firstHeading={"Transaction Details"}
              icon={<AssignmentOutlinedIcon alt="Transactions" className="iconsSize" style={{ color: colorBrandObject.sideBarSelectedOptionBackground }} />} /> </div>
            <div className="refund-capture">

              <div className={`nav-transaction-id  `}>
                {!loading ? (
                  <>
                    <Typography
                      className="labelSemiBold font-text-low"
                      sx={{ marginLeft: "6px" }}
                    >
                      Transaction ID:
                    </Typography>
                    <div className="txn-id-copy-btn">
                      <Typography
                        className="bodyB2SemiBold"
                        sx={{ marginRight: "4px" }}
                      >
                        {gridData["basicDetails.transactionId"]}
                      </Typography>
                      <div
                        className="copy-button"
                        onClick={() =>
                          handleCopy(gridData["basicDetails.transactionId"])
                        }
                      >
                        <img src="/assets/orderDetailsIcons/copy.svg" />
                      </div>
                    </div>
                  </>
                ) : (
                  <Skeleton
                    width={100}
                    height={22}
                    variant="rounded"
                    sx={{
                      background:
                        "linear-gradient(98deg, #F8F8FF -0.82%, rgba(250, 250, 255, 0.60) 113.08%)",
                    }}
                  />
                )}
              </div>

              {handleShowRefresh()}
              {handleShowVoid()}
              {handleShowCapture()}
              {handleShowRefund()}
              {handleSplitPayment()}
            </div>

          </div >
          <div className="root-g">
            <div className="g1g2">
              <div className="g1">
                {!loading ? (
                  <Item sx={{ minHeight: "233px" }}>
                    <div className="card-logo">
                      <div style={{ stroke: iconDefaultColor }}>
                        <CoinsColoredIcon
                          stroke={`${colorBrandObject?.primaryButtonColor}`}
                        />
                      </div>
                    </div>
                    <div className="card-details">
                      <Typography className="bodyB1MediumColored">
                        Summary
                      </Typography>
                      <Typography
                        className="labelSemiBoldColored"
                        sx={{ paddingTop: "20px" }}
                      >
                        Amount
                      </Typography>
                      {gridData["basicDetails.authMoney.amountLocaleFull"] && (
                        <div className="card-amount-info">
                          <Typography
                            className="headerH1Medium"
                            sx={{
                              paddingRight: "12px",
                            }}
                          >{`${gridData["authorisation.money.currencyCode"] ||
                            gridData["basicDetails.authMoney.currencyCode"]
                            }
                              ${gridData[
                            "basicDetails.authMoney.amountLocaleFull"
                            ]
                            }`}</Typography>

                          {recentOperation &&
                            statusColor != "" &&
                            statusFontColor != "" && (
                              <div
                                className={`card-payment-status ${statusColor}`}
                              >
                                <Typography
                                  className={`bodyB2Medium ${statusFontColor}`}
                                >
                                  {recentOperation?.latestStatusLabel}
                                </Typography>
                                {/* <div
                                  className="toolTip"
                                  style={{ marginRight: "-8px" }}
                                >
                                  {recentOperation?.latestStatusInfo}
                                </div> */}
                              </div>
                            )}
                        </div>
                      )}
                      <div style={{ paddingRight: "36px" }}>
                        <Divider />
                      </div>
                      <div className="card-payment-info">
                        <div className="card-details text-limiter">
                          <OrderCategoryDetailsGrid
                            categories={[
                              "Order ID",
                              "Method",
                              "Type",
                              "Last Updated",
                              "Recurring Ref. Id",
                            ]}
                            data={[
                              gridData["basicDetails.context.orderId"],
                              gridData["basicDetails.paymentMethod.brand"]
                                ? gridData["basicDetails.paymentMethod.brand"]
                                : gridData["basicDetails.emiMethod.brand"],
                              paymentMethodData?.find(
                                (obj) =>
                                  obj?.brand ===
                                  gridData["basicDetails.emiMethod.brand"] ||
                                  obj?.brand ===
                                  gridData["basicDetails.paymentMethod.brand"]
                              )?.typeTitle,
                              gridData["basicDetails.updatedOnLocale"],
                              gridData[
                              "recurringPreDebitNotification.recurring.reference.tokenDetails.token"
                              ],
                            ]}
                            paymentMethodData={paymentMethodData}
                          />
                        </div>
                      </div>
                    </div>
                  </Item>
                ) : (
                  <Skeleton
                    variant="rounded"
                    height={250}
                    sx={{
                      borderRadius: "20px",
                      background:
                        "linear-gradient(98deg, #F8F8FF -0.82%, rgba(250, 250, 255, 0.60) 113.08%)",
                    }}
                  />
                )}
              </div>
              <div className="g1">
                {!loading ? (
                  <Item sx={{ flexDirection: "column" }}>
                    <div style={{ display: "flex" }}>
                      <div className="card-logo">
                        <div style={{ stroke: iconDefaultColor }}>
                          <MoneyStackColored
                            stroke={`${colorBrandObject?.primaryButtonColor}`}
                          />
                        </div>
                      </div>
                      <div className="card-payment-info">
                        <div className="card-details">
                          <Typography className="bodyB1MediumColored">
                            Payment Details
                          </Typography>
                          <OrderCategoryDetailsGrid
                            categories={[
                              "Transaction ID",
                              "Transaction Type",
                              "Processor",
                              "Country Code",
                              "Currency Code",
                              "Transaction Date & Time",
                            ]}
                            data={[
                              gridData["basicDetails.transactionId"],
                              `${gridData["authorisation.paymentType"] === "A"
                                ? "Auth"
                                : "Sale"
                              }`,

                              gridData?.pspResponses
                                ?.map(
                                  (item) =>
                                    processorData?.find(
                                      (psp) => item?.pspCode === psp?.pspCode
                                    )?.title
                                )
                                ?.slice(-1)[0],
                              gridData["basicDetails.context.countryCode"],
                              gridData["basicDetails.authMoney.currencyCode"],
                              gridData["authorisation.addedOnLocale"],
                            ]}
                          />
                        </div>
                        <div style={{ paddingRight: "36px" }}>
                          <Divider />
                        </div>
                      </div>
                    </div>



                    <div style={{ display: "flex", paddingTop: "24px" }}>
                      <div className="card-logo">
                        <div style={{ stroke: iconDefaultColor }}>
                          <CoinColoredIcon
                            stroke={`${colorBrandObject?.primaryButtonColor}`}
                          />
                        </div>
                      </div>
                      <div className="card-payment-info">
                        <div className="card-details">
                          <Typography className="bodyB1MediumColored">
                            Payment Method
                          </Typography>

                          {gridData["basicDetails.paymentMethod.type"] ===
                            "Wallet" ? (
                            <OrderCategoryDetailsGrid
                              categories={[
                                "Method",
                                "Type",
                                "Wallet Holder Name",
                              ]}
                              data={[
                                gridData["basicDetails.paymentMethod.brand"],
                                paymentMethodData?.find(
                                  (obj) =>
                                    obj?.brand ===
                                    gridData["basicDetails.paymentMethod.brand"]
                                )?.typeTitle,
                                `${gridData["basicDetails.shopper.firstName"]
                                } ${gridData["basicDetails.shopper.lastName"] ??
                                ""
                                }`,
                              ]}
                              paymentMethodData={paymentMethodData}
                            />
                          ) : gridData["basicDetails.paymentMethod.type"] ===
                            "Card" ||
                            gridData["basicDetails.emiMethod.brand"] ? (
                            <OrderCategoryDetailsGrid
                              categories={[
                                "Method",
                                "Type",
                                "Issuer",
                                "Classification",
                                "Card Holder Name",
                                "First 6 Digits",
                                "Last 4 Digits",
                              ]}
                              data={[
                                gridData["basicDetails.paymentMethod.brand"],
                                paymentMethodData?.find(
                                  (obj) =>
                                    obj?.brand ===
                                    gridData["basicDetails.paymentMethod.brand"]
                                )?.typeTitle,
                                gridData[
                                "basicDetails.emiMethod.cardlessEmiProvider"
                                ] ||
                                (isStringAndNotNumber(
                                  gridData["basicDetails.issuer.name"]
                                ) &&
                                  gridData["basicDetails.issuer.name"]),
                                gridData[
                                "basicDetails.paymentMethod.classification"
                                ],
                                gridData["authorisation.accountHolderName"],
                                gridData["authorisation.first6Digits"],
                                gridData["authorisation.last4Digits"],
                              ]}
                              paymentMethodData={paymentMethodData}
                            />
                          ) : gridData["basicDetails.paymentMethod.type"] ===
                            "Upi" ? (
                            <OrderCategoryDetailsGrid
                              categories={[
                                "Method",
                                "Type",
                                "UPI ID",
                                "Application",
                              ]}
                              data={[
                                gridData["basicDetails.paymentMethod.brand"],
                                paymentMethodData?.find(
                                  (obj) =>
                                    obj?.brand ===
                                    gridData["basicDetails.paymentMethod.brand"]
                                )?.typeTitle,
                                upiId,
                                gridData["basicDetails.paymentMethod.subBrand"],
                              ]}
                              paymentMethodData={paymentMethodData}
                            />
                          ) : (
                            <OrderCategoryDetailsGrid
                              categories={["Method", "Type"]}
                              data={[
                                gridData["basicDetails.paymentMethod.brand"],
                                paymentMethodData?.find(
                                  (obj) =>
                                    obj?.brand ===
                                    gridData["basicDetails.paymentMethod.brand"]
                                )?.typeTitle,
                              ]}
                              paymentMethodData={paymentMethodData}
                            />
                          )}
                        </div>
                        <div style={{ paddingRight: "36px" }}>
                          <Divider />
                        </div>
                      </div>
                    </div>

                    {orderDetailsData?.authorisation?.splitSettlements?.length && <SplitPaymentDetails details={orderDetailsData} />}

                    {
                      gridData["basicDetails.emiMethod.brand"] && (
                        <div style={{ display: "flex", paddingTop: "24px" }}>
                          <div className="card-logo">
                            <img src="/assets/coin.svg" />
                          </div>
                          <div className="card-payment-info">
                            <div className="card-details">
                              <Typography className="bodyB1MediumColored">
                                EMI Details
                              </Typography>
                              <OrderCategoryDetailsGrid
                                categories={["Total Amount", "Tenure"]}
                                data={[
                                  [
                                    `${gridData["authorisation.money.currencySymbol"]}
                                ${gridData["basicDetails.authMoney.amountLocaleFull"]}`,
                                  ],
                                  gridData["basicDetails.emiMethod.duration"],
                                ]}
                                paymentMethodData={paymentMethodData}
                              />
                            </div>
                            <div style={{ paddingRight: "36px" }}>
                              <Divider />
                            </div>
                          </div>
                        </div>
                      )
                    }
                    {
                      gridData?.offers?.length > 0 && (
                        <div style={{ display: "flex", paddingTop: "24px" }}>
                          <div className="card-logo">
                            <div style={{ stroke: iconDefaultColor }}>
                              <UserCheckColored
                                stroke={`${colorBrandObject?.primaryButtonColor}`}
                              />
                            </div>
                          </div>

                          <div className="card-payment-info">
                            <div className="card-details text-limiter">
                              <Typography className="bodyB1MediumColored">
                                Offer Details
                              </Typography>
                              <OrderCategoryDetailsGrid
                                categories={[
                                  "Original Amount",
                                  "Offer Type",
                                  "Discount Type",
                                  "Discount Applied",
                                  "Offer Applied",
                                ]}
                                data={[
                                  gridData["authorisation.money.currencyCode"] +
                                  " " +
                                  gridData[
                                  "basicDetails.originalAuthAmountLocale"
                                  ],
                                  gridData?.offers?.map(
                                    (item) => item?.discount?.type
                                  ),
                                  gridData?.offers?.map((item) =>
                                    item?.discount?.amount
                                      ? "Flat"
                                      : item?.discount?.percentage
                                        ? "Percentage"
                                        : ""
                                  ),
                                  gridData["authorisation.money.currencyCode"] +
                                  " " +
                                  gridData?.offers?.map(
                                    (item) => item?.appliedDiscountAmountLocale
                                  ),
                                  gridData?.offers?.map((item) => item?.code),
                                ]}
                              />
                            </div>
                            <div style={{ paddingRight: "36px" }}>
                              <Divider />
                            </div>
                          </div>
                        </div>
                      )
                    }
                    {
                      !isEmpty(
                        orderDetailsData?.authorisation?.dccQuotationDetails
                      ) && (
                        <div style={{ display: "flex", paddingTop: "24px" }}>
                          <div className="card-logo">
                            <div style={{ stroke: iconDefaultColor }}>
                              <ClockCheckedColoredIcon
                                stroke={`${colorBrandObject?.primaryButtonColor}`}
                              />
                            </div>
                          </div>
                          <div className="card-payment-info">
                            <div className="card-details text-limiter">
                              <Typography className="bodyB1MediumColored">
                                Currency Details
                              </Typography>
                              <OrderCategoryDetailsGrid
                                categories={[
                                  "DCC Provider",
                                  "Transaction currency",
                                  "Exchange rate",
                                  "Margin",
                                  `Transaction Total ${gridData["authorisation.dccQuotationDetails.dccMoney.currencyCode"]}`,
                                ]}
                                data={[
                                  gridData[
                                  "authorisation.dccQuotationDetails.dspCode"
                                  ],
                                  gridData[
                                  "authorisation.dccQuotationDetails.dccMoney.currencyCode"
                                  ],
                                  `1 ${gridData["authorisation.money.currencyCode"]} = ${gridData["authorisation.dccQuotationDetails.fxRate"]} ${gridData["authorisation.dccQuotationDetails.dccMoney.currencyCode"]}`,
                                  `${gridData["authorisation.dccQuotationDetails.marginPercent"]}%`,
                                  `${gridData["authorisation.dccQuotationDetails.dccMoney.currencyCode"]} ${gridData["authorisation.dccQuotationDetails.dccMoney.amount"]}`,
                                ]}
                              />
                            </div>
                            <div style={{ paddingRight: "36px" }}>
                              <Divider />
                            </div>
                          </div>
                        </div>
                      )
                    }

                    <div style={{ display: "flex", paddingTop: "24px" }}>
                      <div className="card-logo">

                        <div style={{ stroke: iconDefaultColor }}>
                          <UserCheckColored
                            stroke={`${colorBrandObject?.primaryButtonColor}`}
                          />
                        </div>
                      </div>

                      <div className="card-payment-info">
                        <div className="card-details text-limiter">
                          <Typography className="bodyB1MediumColored">
                            Customer Details
                          </Typography>
                          <OrderCategoryDetailsGrid
                            categories={[
                              "Customer Reference",
                              "Phone Number",
                              "Customer First Name",
                              "Customer Last Name",
                              "Email",
                            ]}
                            data={[
                              gridData["basicDetails.shopper.uniqueReference"],
                              gridData["basicDetails.shopper.phoneNumber"],
                              gridData["basicDetails.shopper.firstName"],
                              gridData["basicDetails.shopper.lastName"],
                              gridData["basicDetails.shopper.email"],
                            ]}
                          />
                        </div>
                        <div style={{ paddingRight: "36px" }}>
                          <Divider />
                        </div>
                      </div>
                    </div>
                    {handleShowRefundDetails()}
                    {
                      productData && <div style={{ display: "flex", paddingTop: "24px" }}>
                        <div className="card-logo">
                          <div style={{ stroke: iconDefaultColor }}>
                            <UserCheckColored
                              stroke={`${colorBrandObject?.primaryButtonColor}`}
                            />
                          </div>
                        </div>
                        <div className="card-payment-info">
                          <div className="card-details">
                            <Typography className="bodyB1MediumColored">
                              Product Details
                            </Typography>
                            <div>
                              <div className="order-category-root">
                                {productData?.name && <div className="order-category" style={{ width: "50%" }}>
                                  <Typography className="labelSemiBoldColored">Product Name</Typography>
                                  <Tooltip
                                    title={productData?.name}
                                    placement="right-start"
                                    arrow
                                    followCursor
                                  >
                                    <Typography className="bodyB2SemiBoldColored " sx={{ paddingTop: "8px" }}>{productData?.name}</Typography>
                                  </Tooltip>
                                </div>}

                                {productData?.description && <div className="order-category" style={{ width: "50%" }}>
                                  <Typography className="labelSemiBoldColored">Product Description</Typography>
                                  <ReadMoreText className="bodyB2SemiBoldColored" sx={{ paddingTop: "8px" }}
                                    text={productData?.description}
                                    maxLength={100} />
                                </div>}

                              </div>
                              <div>

                              </div>
                            </div>
                          </div>
                          <div style={{ paddingRight: "36px" }}>
                            <Divider />
                          </div>
                        </div>
                      </div>
                    }
                    {
                      orderDetailsData?.authorisation?.deviceDetails &&
                      (gridData["authorisation.caller.callerType"] ==
                        "PAYMENT_LINK" ? (
                        <div style={{ display: "flex", paddingTop: "24px" }}>
                          <div className="card-logo">
                            <div style={{ stroke: iconDefaultColor }}>
                              <LaptopIcon
                                stroke={`${colorBrandObject?.primaryButtonColor}`}
                              />
                            </div>
                          </div>
                          <div className="card-payment-info">
                            <div className="card-details">
                              <Typography className="bodyB1MediumColored">
                                Traffic Details
                              </Typography>
                              <OrderCategoryDetailsGrid
                                categories={[
                                  "Device Name",
                                  "Device Brand Name",
                                  "Browser",
                                  "Platform",
                                  "Origin",
                                  "Medium",
                                ]}
                                data={[
                                  gridData[
                                  "authorisation.deviceDetails.deviceName"
                                  ],
                                  gridData[
                                  "authorisation.deviceDetails.deviceBrandName"
                                  ],
                                  gridData[
                                  "authorisation.deviceDetails.browser"
                                  ],
                                  gridData[
                                  "authorisation.deviceDetails.platform"
                                  ],
                                  gridData["authorisation.caller.token"],
                                  gridData[
                                  "authorisation.trackingDetails.medium"
                                  ],
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: "flex", paddingTop: "24px" }}>
                          <div className="card-logo">
                            <div style={{ stroke: iconDefaultColor }}>
                              <LaptopIcon
                                stroke={`${colorBrandObject?.primaryButtonColor}`}
                                fill={`${colorBrandObject?.primaryButtonColor}`}
                              />
                            </div>
                          </div>
                          <div className="card-payment-info">
                            <div className="card-details">
                              <Typography className="bodyB1MediumColored">
                                Device Details
                              </Typography>
                              <OrderCategoryDetailsGrid
                                categories={[
                                  "Device Name",
                                  "Device Brand Name",
                                  "Browser",
                                  "Platform",
                                  "Medium",
                                ]}
                                data={[
                                  gridData[
                                  "authorisation.deviceDetails.deviceName"
                                  ],
                                  gridData[
                                  "authorisation.deviceDetails.deviceBrandName"
                                  ],
                                  gridData[
                                  "authorisation.deviceDetails.browser"
                                  ],
                                  gridData[
                                  "authorisation.deviceDetails.platform"
                                  ],
                                  gridData[
                                  "authorisation.trackingDetails.medium"
                                  ],
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </Item >
                ) : (
                  <Skeleton
                    variant="rounded"
                    height={"100vh"}
                    sx={{
                      borderRadius: "20px",
                      background:
                        "linear-gradient(98deg, #F8F8FF -0.82%, rgba(250, 250, 255, 0.60) 113.08%)",
                    }}
                  />
                )
                }
              </div >
            </div >
            <div className="g3">
              {!loading ? (
                <Item sx={{ flexDirection: "column" }}>
                  <div className="card-timeline">
                    <div className="card-logo">
                      <div style={{ stroke: iconDefaultColor }}>
                        <ClockCheckedColoredIcon
                          stroke={`${colorBrandObject?.primaryButtonColor}`}
                        />
                      </div>
                    </div>
                    <Typography className="bodyB1MediumColored">
                      Timeline
                    </Typography>
                  </div>
                  <div style={{ padding: "20px 16px 31px 16px" }}>
                    <Divider />
                  </div>
                  <div className="timeline-details">
                    {gridData &&
                      processorData &&
                      refundReasons &&
                      timeline?.map((operation, index) => {
                        const response = timelineScenarios(
                          operation,
                          refundReasons,
                          timezone,
                          approveTransactionRequest,
                          approvalLoader,
                          handleRejectModal,
                          isAuthorizedPermission
                        );
                        return (
                          response && (
                            <TimelineDetails
                              obj={response}
                              isFirst={index === timeline?.length - 1}
                            />
                          )
                        );
                      })}
                  </div>
                </Item>
              ) : (
                <Skeleton
                  variant="rounded"
                  height={"100vh"}
                  sx={{
                    borderRadius: "20px",
                    background:
                      "linear-gradient(98deg, #F8F8FF -0.82%, rgba(250, 250, 255, 0.60) 113.08%)",
                  }}
                />
              )}
            </div>
          </div >
        </section >
      </div >

      {isRejectModal && <RejectModal modalData={rejectModalData} setModalData={setIsRejectModal} postAction={postActionForRefund} />}
    </>
  );
}

export default OrderDetails;
